var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3574 4.09006C13.9752 3.47416 12.4308 3.32158 10.9548 3.65508C9.4787 3.98858 8.14997 4.79029 7.16676 5.94064C6.18355 7.09099 5.59854 8.52835 5.49897 10.0384C5.3994 11.5484 5.79061 13.0501 6.61426 14.3196C7.4379 15.5891 8.64985 16.5583 10.0694 17.0828C11.4889 17.6072 13.0398 17.6587 14.491 17.2296C15.9422 16.8006 17.2158 15.9139 18.1219 14.7019C19.028 13.4898 19.518 12.0174 19.5188 10.5041V9.79833C19.5188 9.43499 19.8134 9.14044 20.1767 9.14044C20.5401 9.14044 20.8346 9.43499 20.8346 9.79833V10.5045C20.8336 12.3015 20.2517 14.0504 19.1757 15.4897C18.0998 16.929 16.5874 17.9819 14.8641 18.4914C13.1408 19.0009 11.299 18.9398 9.61336 18.317C7.9277 17.6942 6.48851 16.5433 5.51044 15.0357C4.53236 13.5282 4.06779 11.7449 4.18603 9.95178C4.30427 8.15865 4.99897 6.45179 6.16654 5.08574C7.3341 3.7197 8.91196 2.76767 10.6648 2.37164C12.4176 1.97561 14.2515 2.1568 15.893 2.88818C16.2249 3.03607 16.374 3.425 16.2261 3.75689C16.0783 4.08878 15.6893 4.23795 15.3574 4.09006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6417 3.89858C20.8988 4.15537 20.899 4.57193 20.6422 4.82898L12.9667 12.5121C12.8434 12.6356 12.676 12.705 12.5015 12.705C12.3269 12.7051 12.1595 12.6357 12.0361 12.5123L9.73347 10.2097C9.47654 9.95277 9.47654 9.53622 9.73347 9.27929C9.99039 9.02237 10.4069 9.02237 10.6639 9.27929L12.5011 11.1165L19.7113 3.89904C19.9681 3.64199 20.3847 3.64178 20.6417 3.89858Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 22.5 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1.5,
    y: 0.5,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifSuccess);
export default __webpack_public_path__ + "static/media/notif-success.919be7ab515fc2b4924e69f98e7ba641.svg";
export { ForwardRef as ReactComponent };